import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import Utils from '../../../custom/utils';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Button from "@material-ui/core/Button";
;
const moment = require('moment');

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    },
    accountDetails:{
        width:'300px',
        position:'absolute',
        display:'none',
        border:'2px solid #6e6e6e',
        backgroundColor:'white',
        top:0,
        right:50,
        zIndex:1000,
    },
    bankDetails:{
        '&:hover .details_drawer':{
            display:'block'
        }
    }
});

class InvestorWithdrawalRow extends Component {
    showAccountDetails = () => {

        let currency = Utils.getCurrency(this.props.rowData._currency.toUpperCase());

        let amnt = this.props.rowData._amount;

        let content = (
            <div>
              <h3>Investor Details</h3>
              <b>Investor:</b> {this.props.investor._firstname} {this.props.investor._surname}<br />
              <b>Account:</b> {this.props.investor._account}<br /><br />

              <div>
                <h4>Bank Account Details</h4>
                <b>Name:</b> {this.props.rowData._bank_account_name}<br />
                <b>Number:</b> {this.props.rowData._bank_account_number}<br />
                <hr />
                <h4>Bank Details</h4>
                <b>Name:</b> {this.props.rowData._bank_name}<br />
                <b>SWIFT:</b> {this.props.rowData._bank_code}<br />
                <b>City:</b> {this.props.rowData._bank_city}<br />
                <b>State:</b> {this.props.rowData._bank_state}<br />
                <b>Country:</b> {this.props.rowData._bank_country}
              </div>
              <div style={{marginTop:'15px'}}>
                <b>Amount Frozen:</b> {currency.currency_symbol}{Utils.addThousandCommas(amnt, '0,0.00')}<br />
                <b>Fee Allocated:</b> {currency.currency_symbol}{Utils.addThousandCommas(this.props.rowData._fee, '0,0.00')}
              </div>
              <Button variant="outlined" color="secondary" onClick={this.close}>
                Close
              </Button>
            </div>
        )

        this.props.context.update({
            popupContent: content
        })
    }

    close = () =>{
      this.props.context.update({
        popupContent: false,
      })
    };

    depositState(state) {
      let states = Utils.returnWithdrawalState(state)
      return(
        <div className={'kyc-label ' + states[0]}>{states[1]}</div>
      )
    }

    render() {
        const {classes} = this.props;
        let currency = Utils.getCurrency(this.props.rowData._currency.toUpperCase());

        return (
            <tr className={classes.tableRow}>
                <td>{moment(this.props.rowData._ts_created).format('L')}</td>
                <td className={'text-center pl-2'}>{this.depositState(this.props.rowData._status)}</td>
                <td className={'text-right pl-2'}>{currency.currency_symbol}{Utils.addThousandCommas(this.props.rowData._amount, '0,0.00')}</td>
                <td className={'text-center pl-2'}>
                    <div className={classes.bankDetails} onClick={this.showAccountDetails}><FontAwesomeIcon className={classes.icon} icon="piggy-bank" /></div>
                </td>
            </tr>
        )
    }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(InvestorWithdrawalRow)));
